/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Void_Reason_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Why are these entries being voided?" |
*
* @param {Partner_Admin_Commission_Void_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_void_reason_placeholder = /** @type {((inputs?: Partner_Admin_Commission_Void_Reason_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Void_Reason_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum werden diese Einträge storniert?")
	return /** @type {LocalizedString} */ ("Why are these entries being voided?")
});